import './sectionHeader.scss';

interface ISectionHeaderProps {
    title: string;
    description?: string;
}

const SectionHeader: React.FC<ISectionHeaderProps> = ({ title, description }) => {
    return (
        <div>
            <div className="headerTitle">
                <h1 className="headerTitle__value">{title}</h1>
            </div>
            {description && <p className="headerTitle__description">{description}</p>}
        </div>
    );
};

export default SectionHeader;
